import { ErrorResponse } from "../../../utils";
import { State } from "./state";
import { Action as TAction, StoreDispatchProps } from "../../../Store";
import { Dispatch } from "redux";
import { actionCreator } from "../../../ajax";

export namespace Actions {
  // ACTION TYPES
  export const REQUEST_GET = "io/request/ipconfig/get";
  export const REQUEST_POST = "io/request/ipconfig/post";
  export const RESPONSE_GET = "io/response/ipconfig/get";
  export const RESPONSE_POST = "io/response/ipconfig/post";
  export const EDIT = "io/edit/ipconfig";

  // ACTION INTERFACES
  type Requests = GetRequest | PostRequest;
  export interface GetRequest extends TAction<typeof REQUEST_GET> {}
  export interface PostRequest extends TAction<typeof REQUEST_POST> {
    data: Partial<State.Data>;
  }
  export interface GetResponse extends TAction<typeof RESPONSE_GET> {
    data: State.ServerResponse;
  }
  export interface PostResponse extends TAction<typeof RESPONSE_POST> {
    data: ErrorResponse;
  }
  export interface Edit extends TAction<typeof EDIT> {
    data: Partial<State.Data>;
  }
  export interface DispatchProps extends StoreDispatchProps<State.Data> {}

  // ACTIONS
  export const getRequest = actionCreator<GetRequest>(REQUEST_GET);
  export const getResponse = actionCreator<GetResponse>(RESPONSE_GET);
  export const postRequest = actionCreator<PostRequest>(REQUEST_POST);
  export const postResponse = actionCreator<PostResponse>(RESPONSE_POST);
  export const edit = actionCreator<Edit>(EDIT);
  export function fetchRequest(): GetRequest;
  export function fetchRequest(data: Partial<State.Data>): PostRequest;
  export function fetchRequest(data?: Partial<State.Data>): Requests {
    return data ? postRequest({ data }) : getRequest();
  }

  export const bindDispatchProps = (dispatch: Dispatch) => {
    return {
      edit: (data: Partial<State.Data>) => dispatch(edit({ data })),
      fetch: (data?: Partial<State.Data>) =>
        dispatch(data ? fetchRequest(data) : fetchRequest())
    };
  };
}
export default Actions;
